var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgSound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 55,
    viewBox: "0 0 58 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3329_3476)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48617 0.0638875L10.5449 0.865022C10.5449 0.865022 11.8201 -0.00577643 12.1009 2.88982e-05C12.3817 0.0116395 39.0847 0.185799 39.3011 0.191605C39.5117 0.19741 46.8587 0.418012 46.8587 0.418012C46.8587 0.418012 49.7542 1.84032 50.1812 2.20025C50.6023 2.56598 53.3633 7.55276 53.4277 8.40034C53.4978 9.24211 53.0065 24.4404 53.0065 24.4404L52.0179 26.4433L52.9129 26.809L51.8541 42.3034C51.8541 42.3034 49.3389 45.5718 48.9879 45.7054C48.6311 45.8331 16.1371 46.1117 16.1371 46.1117L14.7273 45.0842L13.3878 46.0247C13.3878 46.0247 10.4221 45.8621 10.0653 45.5022C9.7143 45.1422 6.6784 40.0045 6.6784 40.0045C6.6784 40.0045 5.97061 26.8729 6.111 26.5942C6.25139 26.3214 6.46197 24.2895 6.46197 24.2895C6.46197 24.2895 6.1812 23.0181 5.96476 22.4492C5.75418 21.8803 5.46756 15.2158 5.39736 14.583C5.32717 13.9502 4.75977 6.50199 4.75977 6.50199C4.75977 6.50199 6.1695 2.40924 6.52632 2.06672C6.87144 1.73582 9.48617 0.0638875 9.48617 0.0638875Z",
    fill: "url(#paint0_linear_3329_3476)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48617 0.0638875L10.5449 0.865022C10.5449 0.865022 11.8201 -0.00577643 12.1009 2.88982e-05C12.3817 0.0116395 39.0847 0.185799 39.3011 0.191605C39.5117 0.19741 46.8587 0.418012 46.8587 0.418012C46.8587 0.418012 49.7542 1.84032 50.1812 2.20025C50.6023 2.56598 53.3633 7.55276 53.4277 8.40034C53.4978 9.24211 53.0065 24.4404 53.0065 24.4404L52.0179 26.4433L52.9129 26.809L51.8541 42.3034C51.8541 42.3034 49.3389 45.5718 48.9879 45.7054C48.6311 45.8331 16.1371 46.1117 16.1371 46.1117L14.7273 45.0842L13.3878 46.0247C13.3878 46.0247 10.4221 45.8621 10.0653 45.5022C9.7143 45.1422 6.6784 40.0045 6.6784 40.0045C6.6784 40.0045 5.97061 26.8729 6.111 26.5942C6.25139 26.3214 6.46197 24.2895 6.46197 24.2895C6.46197 24.2895 6.1812 23.0181 5.96476 22.4492C5.75418 21.8803 5.46756 15.2158 5.39736 14.583C5.32717 13.9502 4.75977 6.50199 4.75977 6.50199C4.75977 6.50199 6.1695 2.40924 6.52632 2.06672C6.87144 1.73582 9.48617 0.0638875 9.48617 0.0638875Z",
    fill: "url(#paint1_linear_3329_3476)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4333 9.07935C52.0937 11.4711 48.6016 17.7525 48.6016 18.095C48.6016 18.513 48.8823 25.1543 48.8823 25.1543C48.8823 25.1543 51.1636 21.6421 53.1876 18.4898C53.2987 14.9021 53.4157 10.7223 53.4333 9.07935Z",
    fill: "#A4EEFF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M5.95312 22.4607L9.39263 23.4766L6.67846 25.3517L10.1882 23.3199L5.95312 22.4607Z",
    fill: "#4AFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M49.099 45.6239L48.7831 45.3337L44.7703 42.3265C44.7703 42.3265 36.0019 42.013 33.2234 41.9201C30.4449 41.8272 20.6411 42.7445 20.4539 42.7445C20.2668 42.7445 15.3649 42.193 15.3649 42.193C15.3649 42.193 14.698 41.3396 14.154 41.2119C13.7914 41.1306 11.4633 43.6559 9.94238 45.3627C9.98918 45.4323 10.0301 45.4788 10.0535 45.502C10.4103 45.8619 13.376 46.0245 13.376 46.0245L14.7156 45.084L16.1253 46.1116C16.1253 46.1116 48.6193 45.8329 48.9761 45.7052C49.0054 45.6936 49.0463 45.6646 49.0931 45.6181L49.099 45.6239Z",
    fill: "url(#paint2_linear_3329_3476)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M37.0365 45.9081C41.4822 45.8559 45.454 45.8036 47.5071 45.7572C48.0863 45.5366 48.7823 45.3276 48.7823 45.3276L44.7696 42.3204L33.2227 41.9141C33.4449 42.454 35.7555 44.689 37.0365 45.9023V45.9081Z",
    fill: "url(#paint3_linear_3329_3476)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6252 0.0869699C22.2503 0.069554 19.9222 0.0579433 17.9275 0.0405273C17.208 1.24223 16.0381 3.48309 16.0381 3.48309L21.8115 3.79657C21.8115 3.79657 23.5196 1.62538 24.6252 0.0811646V0.0869699Z",
    fill: "url(#paint4_linear_3329_3476)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1805 2.20587C49.771 1.85755 47.0919 0.539745 46.8755 0.429443L43.6992 3.73848C43.6992 3.73848 46.8463 6.31604 47.3493 5.47427C47.6008 5.05048 48.9521 3.59915 50.2331 2.26393C50.2097 2.2407 50.1922 2.21748 50.1746 2.20007L50.1805 2.20587Z",
    fill: "url(#paint5_linear_3329_3476)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75391 6.50763C4.75391 6.50763 4.77145 6.70501 4.79485 7.03592L9.46276 8.06926L12.6215 3.73269L9.48616 0.0637207L6.52046 2.07236L6.42686 2.20008C5.9706 2.97799 4.75391 6.50183 4.75391 6.50183V6.50763Z",
    fill: "url(#paint6_linear_3329_3476)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8713 27.3601L52.5964 26.6866L48.6246 25.6765L48.3906 31.3309L52.2338 36.6312L52.8713 27.3601Z",
    fill: "url(#paint7_linear_3329_3476)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4286 3.83154C12.6334 3.83154 14.3122 3.85476 14.3122 3.6748C14.3122 3.49483 12.1011 2.88982e-05 12.1011 2.88982e-05C11.8203 -0.00577643 10.5451 0.865022 10.5451 0.865022L9.48633 0.0638875C9.48633 0.0638875 12.2239 3.83735 12.4286 3.83735V3.83154Z",
    fill: "url(#paint8_linear_3329_3476)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0253 4.23804C12.0253 4.23804 9.31698 7.59932 9.41057 8.75458C9.50417 9.90403 10.5746 23.2621 10.5746 24.1271C10.5746 24.9921 11.6392 37.0962 11.6392 37.0962C11.6392 37.0962 13.8679 40.8464 14.1545 41.2296C14.447 41.6127 16.2837 42.2861 16.2837 42.2861L44.1625 41.9959C44.1625 41.9959 47.9354 39.8827 48.1343 39.6912C48.3273 39.4996 48.3273 38.1528 48.3273 37.8683V26.246C48.3273 26.246 49.0059 11.0651 49.0059 10.8735C49.0059 10.6819 47.6488 5.49199 47.6488 5.49199C47.6488 5.49199 41.1617 3.47754 40.682 3.47754C40.2024 3.47754 23.5488 3.57042 22.3848 3.57042C21.2207 3.57042 12.0253 4.24384 12.0253 4.24384V4.23804Z",
    fill: "url(#paint9_linear_3329_3476)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M12.0253 4.23804C12.0253 4.23804 9.31698 7.59932 9.41057 8.75458C9.50417 9.90403 10.5746 23.2621 10.5746 24.1271C10.5746 24.9921 11.6392 37.0962 11.6392 37.0962C11.6392 37.0962 13.8679 40.8464 14.1545 41.2296C14.447 41.6127 16.2837 42.2861 16.2837 42.2861L44.1625 41.9959C44.1625 41.9959 47.9354 39.8827 48.1343 39.6912C48.3273 39.4996 48.3273 38.1528 48.3273 37.8683V26.246C48.3273 26.246 49.0059 11.0651 49.0059 10.8735C49.0059 10.6819 47.6488 5.49199 47.6488 5.49199C47.6488 5.49199 41.1617 3.47754 40.682 3.47754C40.2024 3.47754 23.5488 3.57042 22.3848 3.57042C21.2207 3.57042 12.0253 4.24384 12.0253 4.24384V4.23804Z",
    fill: "#034072"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0988 27.3082C47.9935 27.3082 37.207 27.0586 37.207 27.0586C37.207 27.0586 47.7069 28.0165 47.8122 28.0165C47.9175 28.0165 48.0988 27.3082 48.0988 27.3082Z",
    fill: "#4AFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.07,
    d: "M29.9187 20.9686L10.0713 17.1196C10.3345 20.5041 10.5743 23.7145 10.5743 24.1209C10.5743 24.9858 11.639 37.0899 11.639 37.0899C11.639 37.0899 13.8676 40.8402 14.1542 41.2233C14.4467 41.6065 16.2835 42.2799 16.2835 42.2799L26.1165 42.1754C26.7365 38.8722 29.9187 20.9686 29.9187 20.9686Z",
    fill: "url(#paint10_linear_3329_3476)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M40.6758 3.46582C40.1903 3.46582 23.5426 3.55871 22.3785 3.55871C22.1621 3.55871 21.6708 3.58193 21.0098 3.62256C24.4142 9.74138 30.0999 19.9413 30.2871 20.2258C30.4743 20.5045 41.5474 25.7641 48.3153 28.9628V26.2343C48.3153 26.2343 48.9938 11.0534 48.9938 10.8618C48.9938 10.6702 47.6367 5.48027 47.6367 5.48027C47.6367 5.48027 41.1496 3.46582 40.67 3.46582H40.6758Z",
    fill: "url(#paint11_linear_3329_3476)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9172 25.1829C47.9172 25.1829 47.5253 26.2452 47.42 26.3497C47.3147 26.46 37.2477 27.058 37.4232 27.058C37.5987 27.058 47.6715 27.3773 47.7066 27.3076C47.7417 27.2379 48.2799 26.46 48.2799 26.46L47.923 25.1829H47.9172Z",
    fill: "url(#paint12_linear_3329_3476)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8268 3.48324C34.5864 4.87071 17.5351 18.1069 10.5449 23.6509C10.5625 23.8832 10.5683 24.0457 10.5683 24.1212C10.5683 24.9862 11.6329 37.0903 11.6329 37.0903C11.6329 37.0903 12.212 38.0656 12.8204 39.0699C17.8802 32.3938 32.2349 13.7471 40.1493 3.46582C39.5 3.46582 38.3067 3.47743 36.8268 3.48324Z",
    fill: "url(#paint13_linear_3329_3476)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3687 42.1294C34.2469 35.5868 42.9802 19.5467 48.5958 9.17259C48.198 7.59354 47.6481 5.4804 47.6481 5.4804C47.6481 5.4804 47.1158 5.31205 46.3437 5.07983L20.8457 42.2281L30.3745 42.1294H30.3687Z",
    fill: "url(#paint14_linear_3329_3476)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M46.4262 27.8947L30.2933 20.2258L14.833 18.3391L29.9189 20.9689L26.3624 38.5242L30.9133 21.4333L46.4262 27.8947Z",
    fill: "url(#paint15_linear_3329_3476)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M48.1458 34.3613L46.7185 39.0055L43.8698 40.3175L29.9071 40.7994L16.7691 40.1202L13.7507 37.6877L11.4928 32.9506L11.2822 32.939C11.4811 35.2379 11.6449 37.084 11.6449 37.084C11.6449 37.084 13.8736 40.8342 14.1602 41.2174C14.4527 41.6005 16.2894 42.2739 16.2894 42.2739L44.1681 41.9837C44.1681 41.9837 47.9411 39.8705 48.14 39.6789C48.333 39.4874 48.333 38.1405 48.333 37.8561V35.0927C48.2219 34.6341 48.1517 34.3555 48.1517 34.3555L48.1458 34.3613Z",
    fill: "url(#paint16_linear_3329_3476)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M44.1616 41.9896L43.8691 40.3176L46.7178 39.0056L48.1276 39.6848L44.6413 41.7806L44.1616 41.9896Z",
    fill: "url(#paint17_linear_3329_3476)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M16.7628 40.1259L13.7444 37.6935L12.3347 37.5251L12.1768 38.007C12.8553 39.1448 13.9492 40.9561 14.148 41.2173C14.4405 41.6005 16.2773 42.2739 16.2773 42.2739H16.4293C16.8973 42.0881 16.7569 40.1201 16.7569 40.1201L16.7628 40.1259Z",
    fill: "url(#paint18_linear_3329_3476)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M47.6488 5.48588C47.6488 5.48588 41.1617 3.47144 40.682 3.47144C40.2024 3.47144 23.5488 3.56432 22.3848 3.56432C21.2207 3.56432 12.0253 4.23774 12.0253 4.23774C12.0253 4.23774 9.31698 7.59902 9.41057 8.75428C9.49247 9.73538 10.2763 19.5638 10.5103 22.9947L10.6507 23.2386L10.7209 14.2403L11.5047 8.21439C11.5047 8.21439 14.0726 5.59038 14.3593 5.38139C14.6459 5.16659 29.2112 4.17969 31.0654 4.17969C32.9197 4.17969 42.2731 5.31172 42.4895 5.31172C42.706 5.31172 46.7714 7.29714 46.7714 7.29714C46.7714 7.29714 48.1987 14.0313 48.3449 14.5248C48.4443 14.8789 48.4736 19.767 48.4853 22.571C48.6842 18.066 49 11.0009 49 10.8732C49 10.6816 47.6429 5.49169 47.6429 5.49169L47.6488 5.48588Z",
    fill: "#034072"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.6478 5.4858C47.6478 5.4858 45.3547 4.77175 43.3952 4.19702L42.6113 5.34067C43.3133 5.60191 46.7762 7.29126 46.7762 7.29126L47.7355 5.83412C47.677 5.61352 47.6419 5.4858 47.6419 5.4858H47.6478Z",
    fill: "url(#paint19_linear_3329_3476)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.3584 5.3755C14.3584 5.3755 14.487 5.34067 14.6567 5.31164L12.5216 4.19702C12.2057 4.22024 12.0186 4.23185 12.0186 4.23185C12.0186 4.23185 10.3865 6.25211 9.70215 7.69763L11.4979 8.2085C11.4979 8.2085 14.0659 5.58449 14.3525 5.3755H14.3584Z",
    fill: "url(#paint20_linear_3329_3476)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46233 8.0694V10.2986C9.46233 10.2986 6.2568 17.1489 6.34454 16.9864C6.42644 16.818 9.79575 11.5758 9.79575 11.5758L9.8367 15.9124C9.8367 15.9124 10.252 11.4539 10.252 11.2043C10.252 10.9546 9.91859 7.94169 10.1292 7.90105C10.3398 7.86041 12.5392 4.39463 12.586 4.43527C12.6269 4.47591 17.8271 3.85474 17.8271 3.85474L25.5836 3.49481L16.8678 3.44256L17.8681 0.510869L16.0372 3.4832L14.6625 3.40192C14.6625 3.40192 12.3403 0.116107 12.118 0H12.1005C12.042 0.145133 14.0366 3.61091 13.9138 3.65155C13.791 3.69219 12.6211 3.73282 12.6211 3.73282L9.48573 0.0638586L11.8723 3.86054L9.46233 8.0694Z",
    fill: "url(#paint21_linear_3329_3476)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9404 8.88198C48.9404 8.72524 47.7529 4.9808 47.7529 4.9808C47.7529 4.9808 50.2156 2.19425 50.0342 2.35099C49.847 2.50773 47.0042 4.73698 46.9457 4.67312C46.8872 4.60926 44.483 3.80813 44.5415 3.71524C44.6059 3.62236 46.817 0.650029 46.817 0.650029L43.6992 3.74427C43.6992 3.74427 40.2655 3.27984 40.2948 3.1231C40.3182 3.00699 41.9794 1.17831 42.775 0.301709C42.7399 0.301709 42.7106 0.301709 42.6755 0.301709L39.6396 2.97216L35.428 2.94313L32.2459 0.13916C32.0353 0.13916 31.8189 0.13916 31.6024 0.13916L31.8423 0.301709C31.8423 0.301709 35.0536 3.18115 34.808 3.27404C34.5564 3.36692 31.5322 3.55269 31.5322 3.55269C31.5322 3.55269 40.675 3.6746 40.9558 3.76749C41.2366 3.86037 43.7635 4.3248 43.7635 4.3248L46.5538 5.21882L47.3551 5.47425C47.3551 5.47425 48.5426 9.776 48.6654 9.776C48.7883 9.776 48.9462 11.9414 48.9462 11.9414L49.4142 9.61926L52.9999 8.06923C52.9999 8.06923 48.9462 9.02711 48.9462 8.87617L48.9404 8.88198Z",
    fill: "url(#paint22_linear_3329_3476)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9523 14.333L48.7534 24.3008C48.7534 24.3008 53.316 17.7407 53.1172 18.1355C52.9183 18.5303 48.888 25.1541 48.888 25.1541L52.93 24.4517L48.6247 25.6824L48.4961 38.9302L51.4559 42.8372L48.1334 39.6849C48.1334 39.6849 47.7649 26.4661 47.8351 25.7463C47.8994 25.0264 48.9582 14.333 48.9582 14.333H48.9523Z",
    fill: "url(#paint23_linear_3329_3476)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M9.39263 23.4759L8.0648 23.1276L5.95312 22.4658C6.16371 23.0347 6.45033 24.3061 6.45033 24.3061C6.45033 24.3061 6.38014 24.9505 6.29825 25.5601L9.39263 23.4818V23.4759Z",
    fill: "url(#paint24_linear_3329_3476)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93682 17.8105V22.8728L10.8844 33.8971C10.8844 33.8971 6.28088 31.0641 6.53241 31.1686C6.78393 31.2673 10.5861 34.7447 10.8376 34.9943C11.0892 35.2439 11.2881 37.1771 11.2881 37.1771L7.28699 40.0101L11.8438 38.1234L14.2245 41.2641L12.3468 37.5312C12.3468 37.5312 11.3933 33.3572 11.4928 32.9624C11.5922 32.5677 10.4399 22.3387 10.4399 22.0891C10.4399 21.8394 9.93682 17.8164 9.93682 17.8164V17.8105Z",
    fill: "url(#paint25_linear_3329_3476)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3701 46.0297L14.7155 45.0892L16.1252 46.1168L16.1311 43.0574L13.3701 46.0297Z",
    fill: "url(#paint26_linear_3329_3476)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9463 40.3C46.3731 40.5439 44.2029 41.5308 44.2029 41.5308C44.2029 41.5308 29.3101 41.7572 28.6549 41.7572C27.9998 41.7572 20.4714 42.0823 19.6525 42.1636C18.8336 42.2448 16.2832 42.2739 16.2832 42.2739C16.2832 42.2739 20.3896 42.5699 20.4656 42.6512C20.5475 42.7325 19.1553 45.7396 19.1553 45.7396C19.1553 45.7396 21.0389 42.7325 21.3664 42.8138C21.694 42.895 34.3757 42.1636 34.3757 42.1636L44.7703 42.3261L48.7831 45.3333L45.6185 41.6469L46.9463 40.3Z",
    fill: "#4AFFFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M48.625 25.6767C48.625 25.6767 50.9473 26.2224 52.5968 26.681L52.0177 26.443L53.0063 24.4402L48.625 25.6709V25.6767Z",
    fill: "url(#paint27_linear_3329_3476)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M10.773 13.8049L9.91309 15.0937C10.1471 18.066 10.3927 21.3054 10.5097 22.9948L10.6501 23.2386L10.7203 14.2403L10.7788 13.8107L10.773 13.8049Z",
    fill: "url(#paint28_linear_3329_3476)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.3494 14.5128C48.4196 14.7624 48.4606 17.2994 48.4723 19.7492C48.5191 19.7376 48.5659 19.7318 48.6127 19.7202C48.794 15.5752 48.9987 10.9658 48.9987 10.8555C48.9987 10.8148 48.9402 10.5652 48.8525 10.1995L47.665 11.4476C47.9868 12.9338 48.2851 14.2922 48.3436 14.507L48.3494 14.5128Z",
    fill: "url(#paint29_linear_3329_3476)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M12.8617 45.385C12.1539 45.6637 11.5631 45.7972 11.335 45.8436C12.2767 45.9713 13.3706 46.0294 13.3706 46.0294L13.4408 45.9771L16.1257 43.0513C16.1257 43.0513 13.7567 45.0251 12.8558 45.3792L12.8617 45.385Z",
    fill: "#4AFFFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M18.032 46.1001C17.488 46.0072 16.6456 45.8562 16.6281 45.8156C16.5988 45.7517 16.1367 43.1858 16.1367 43.1858C16.1484 43.2613 16.1367 45.4847 16.1367 46.1117C16.2128 46.1117 16.903 46.1117 18.032 46.0943V46.1001Z",
    fill: "#4AFFFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07066 23.1225L5.95898 22.4607C6.09352 22.8206 6.25731 23.4534 6.35675 23.8772C6.65508 23.8656 8.04141 23.7959 9.02413 23.7205L9.39849 23.4708L8.07066 23.1225Z",
    fill: "url(#paint30_linear_3329_3476)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M16.2891 32.5042C16.2891 32.5042 20.3135 31.4302 21.694 31.6102C23.0745 31.7901 25.3616 32.2662 24.999 32.5622C24.6363 32.8583 23.4372 33.2357 22.7762 33.2183C20.4305 33.1602 16.2891 32.5042 16.2891 32.5042Z",
    fill: "url(#paint31_linear_3329_3476)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M26.3912 32.3877C26.1747 32.3877 25.3148 32.3238 24.765 32.2832C24.999 32.3819 25.0984 32.4806 24.999 32.5619C24.6363 32.8579 23.4372 33.2353 22.7762 33.2179C20.4305 33.1598 16.2891 32.5038 16.2891 32.5038C16.2891 32.5038 21.1968 33.6533 22.355 33.7984C23.5191 33.9435 25.3324 32.7534 25.7711 32.678C26.2098 32.6083 26.7187 32.3877 26.3912 32.3877Z",
    fill: "#4AFFFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M18.0732 32.4283C18.0732 32.4283 20.5651 31.7665 21.9866 31.9349C23.4138 32.1032 24.4317 32.4632 24.4317 32.4632L18.0732 32.4283Z",
    fill: "url(#paint32_linear_3329_3476)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3329_3476",
    x: 0.753906,
    y: 0,
    width: 56.6807,
    height: 54.1167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3329_3476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3329_3476",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3329_3476",
    x1: 24.0105,
    y1: 59.8181,
    x2: 34.8386,
    y2: -30.9038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3329_3476",
    x1: 24.0105,
    y1: 59.8181,
    x2: 34.8386,
    y2: -30.9038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3329_3476",
    x1: 33.902,
    y1: 27.5868,
    x2: 26.9709,
    y2: 56.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3329_3476",
    x1: 43.9273,
    y1: 31.0755,
    x2: 38.3113,
    y2: 55.5346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3329_3476",
    x1: 16.3657,
    y1: 8.57436,
    x2: 23.0739,
    y2: -3.23689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3329_3476",
    x1: 44.3076,
    y1: 7.62224,
    x2: 48.7777,
    y2: -0.261559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3329_3476",
    x1: 4.11046,
    y1: 12.3594,
    x2: 11.929,
    y2: -1.40389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3329_3476",
    x1: 55.8137,
    y1: 19.4184,
    x2: 47.9173,
    y2: 36.8853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3329_3476",
    x1: 14.6105,
    y1: -8.88212,
    x2: 10.4528,
    y2: 7.85787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3329_3476",
    x1: 28.2109,
    y1: -9.89793,
    x2: 33.4886,
    y2: 96.4074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3329_3476",
    x1: 42.2494,
    y1: -4.8245,
    x2: 1.91131,
    y2: 53.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3329_3476",
    x1: 28.2281,
    y1: -24.6842,
    x2: 41.1882,
    y2: 37.2518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3329_3476",
    x1: 49.9938,
    y1: 16.5736,
    x2: 38.1882,
    y2: 33.6787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3329_3476",
    x1: 37.4527,
    y1: -12.7949,
    x2: 6.28304,
    y2: 56.1185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3329_3476",
    x1: 49.8242,
    y1: -7.19843,
    x2: 18.6604,
    y2: 61.7207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3329_3476",
    x1: 25.0228,
    y1: -3.28573,
    x2: 34.4489,
    y2: 41.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3329_3476",
    x1: 28.9068,
    y1: 16.4344,
    x2: 30.7102,
    y2: 52.4927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3329_3476",
    x1: 45.5538,
    y1: 41.1884,
    x2: 42.0443,
    y2: 50.6453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3329_3476",
    x1: 14.2826,
    y1: 40.3117,
    x2: 11.0329,
    y2: 49.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3329_3476",
    x1: 44.8575,
    y1: -0.650425,
    x2: 45.4107,
    y2: 10.3569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3329_3476",
    x1: 11.7729,
    y1: -1.55606,
    x2: 12.4412,
    y2: 11.8025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3329_3476",
    x1: 15.1539,
    y1: -5.80533,
    x2: 17.3894,
    y2: 39.3154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3329_3476",
    x1: 49.8587,
    y1: -25.8861,
    x2: 37.9334,
    y2: 22.1781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3329_3476",
    x1: 70.2445,
    y1: -50.9827,
    x2: 39.3875,
    y2: 73.3904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3329_3476",
    x1: 9.49793,
    y1: 15.7258,
    x2: 6.17061,
    y2: 29.1422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3329_3476",
    x1: 28.4271,
    y1: -35.4649,
    x2: 3.13488,
    y2: 66.4797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3329_3476",
    x1: 13.3701,
    y1: 44.5842,
    x2: 16.1311,
    y2: 44.5842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3329_3476",
    x1: 52.55,
    y1: 20.8467,
    x2: 49.7797,
    y2: 28.5696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3329_3476",
    x1: 9.61476,
    y1: 0.0869468,
    x2: 11.205,
    y2: 31.8723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3329_3476",
    x1: 47.5831,
    y1: -3.65204,
    x2: 49.1907,
    y2: 28.4759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3329_3476",
    x1: 7.79573,
    y1: 20.812,
    x2: 7.54797,
    y2: 25.2823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3329_3476",
    x1: 20.8517,
    y1: 28.6553,
    x2: 20.3792,
    y2: 38.4956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3329_3476",
    x1: 21.3373,
    y1: 30.6171,
    x2: 21.1298,
    y2: 34.9422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSound);
export default __webpack_public_path__ + "static/media/bg-sound.svg";
export { ForwardRef as ReactComponent };